import { MetaDataSet } from '../DataSet/Meta';
import { IDataHandler } from '../IDataHandler';
import { TrackingEventName } from '../TrackingEvent';

export class MetaDataHandler implements IDataHandler<MetaDataSet> {
    public data: MetaDataSet = new MetaDataSet();

    public getEventData(eventName: TrackingEventName): MetaDataSet {
        /* TODO: JS INIT TIME
        if (typeof window !== 'undefined') {
            this.data.durationSinceJSEnabled =
                Date.now() - (window as any).JS_INIT_TIME;
                this.data.durationSinceJSEnabled = (this.data.durationSinceJSEnabled) ? this.data.durationSinceJSEnabled : undefined;
        }
        */
        if (eventName === TrackingEventName.newPlayer) {
            newPlayerOmit.forEach((key: keyof MetaDataSet) => {
                this.data[key] = undefined as never;
            });
        }

        return this.data;
    }

    public clearData(): void {
        this.data = new MetaDataSet();
    }
}

const newPlayerOmit: (keyof MetaDataSet)[] = [
    'highestLevel',
    'lastLevelAttempted',
    'lastLevelWon',
    'sessionNum',
    'musicIsOn',
    'soundIsOn',
    'changerBooster',
    'massRemoveBooster',
    'freeEntryBooster',
    'plus5Booster',
    'removeOneBooster',
    'jokerBooster',
    'undoBooster',
    'canisterCardBoosters',
    'extraWildcardsBoosters',
    'removeCardsBoosters',
    'coins',
    'stars',
    'numFriendsInApp',
];
